import React from 'react'

// material ui
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

// components
import Loading from 'components/atoms/Loading'

// decorators
import { limitedAvailabilityByRegion } from 'lib/cart/decorators/softClose'

const LimitedAvailabilityModal = props => {
  const { open, onClose, session, plan, loading } = props

  const regions = limitedAvailabilityByRegion(session, plan)

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Locations with limited availability</DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <Loading />
        ) : regions.length === 0 ? (
          <Typography variant='body2' color='text.secondary'>
            There are no additional locations with limited availability.
          </Typography>
        ) : (
          <>
            <Typography variant='body2' gutterBottom>
              Due to high demand, these locations have reached capacity on
              select dates. Your Passes cannot be used during the following
              dates:
            </Typography>
            {regions.map(region => (
              <Box key={region.regionTitle} my={2}>
                <Typography variant='subtitle2' gutterBottom>
                  {region.regionTitle}
                </Typography>
                {region.locations.map(location => (
                  <Typography key={location.id} variant='body2' gutterBottom>
                    <strong>{location.name}</strong>:{' '}
                    {location.restrictedRanges.join(', ')}
                  </Typography>
                ))}
              </Box>
            ))}
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default LimitedAvailabilityModal
